export function inr(n: number | null | undefined): string {
  return "₹" + Math.round(n || 0).toLocaleString("en-IN");
}

const locale = (lang: string) => (lang === "hi" ? "hi-IN" : "en-IN");

export function monthLabel(m: string, lang = "en", long = false): string {
  const [y, mo] = m.split("-").map(Number);
  return new Date(y, mo - 1, 1).toLocaleDateString(locale(lang), { month: long ? "long" : "short", year: "numeric" });
}

export function dateLabel(d: string | null | undefined, lang = "en"): string {
  if (!d) return "-";
  return new Date(d.length === 10 ? d + "T00:00:00" : d).toLocaleDateString(locale(lang), { day: "numeric", month: "short", year: "numeric" });
}

export function todayISO(): string {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export function shiftMonth(m: string, n: number): string {
  const [y, mo] = m.split("-").map(Number);
  const idx = y * 12 + mo - 1 + n;
  return `${Math.floor(idx / 12)}-${String((idx % 12) + 1).padStart(2, "0")}`;
}

export function waLink(phone: string, text: string): string {
  return `https://wa.me/91${phone}?text=${encodeURIComponent(text)}`;
}

export function reminderText(name: string, amount: number, month: string, pg: string, link?: string): string {
  const base = `Hi ${name}, a gentle reminder from ${pg}: rent of ${inr(amount)} for ${monthLabel(month, "en", true)} is pending. Please pay at the earliest. Thank you!`;
  return link ? `${base}\nView your rent & receipts: ${link}` : base;
}
